import styled from "styled-components";
import ScrollAnimation from "react-animate-on-scroll";

interface IDot {
  color: string;
}

export const ChartButtonWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
`;

export const ChartBodyWrapper = styled(ScrollAnimation)`
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  background-color: ${(props) =>
        props.backgroundColor ? props.backgroundColor : "#f7f9fb"};
  width: ${(props) => props.width};
  transition: background-color 0.3s, box-shadow 0.3s;
  &:hover {
    box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.12);
    background-color: white;
  }
  ${(props) =>
        props.zoom
    && `
    position: relative;
    z-index: 1;        
    transform: scale(1.5)
  `}
`;

export const ChartDot = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  margin-left: 18px;
  &:before {
    display: block;
    margin-right: 5px;
    content: "";
    border-radius: 50%;
    width: 15px;
    height: 15px;
    background-color: ${(props: IDot) => props.color};
  }
  &:first-child {
    margin-left: 0;
  }
`;

export const ChartDotsWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 12vh;
  min-height: 50px;
`;

export const ChartDots = styled.div`
  display: flex;
  justify-content: space-between;
`;
